import React from "react";
import { LIVE_STATE_BADGE } from "../utils/constants";

const CareWatchLiveStatusBadge = ({ state }) => {
  const badge = LIVE_STATE_BADGE[state];
  if (!badge) return null;

  return (
    <span
      className="inline-flex h-[22px] items-center justify-center rounded-full px-2.5 text-[10px] font-semibold whitespace-nowrap"
      style={{ background: badge.bg, color: badge.text }}
    >
      {badge.label}
    </span>
  );
};

export default CareWatchLiveStatusBadge;
